import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.ts';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
import { definePreset } from '@primevue/themes';
import { VueQueryPlugin } from '@tanstack/vue-query';

import './font-awesome-setup.ts';

// Critical styles only
import 'primeicons/primeicons.css';
import '@/assets/styles.scss';
import '@/assets/tailwind.css';
import { createGtag } from 'vue-gtag';

const gtag = createGtag({
    tagId: 'G-6V8RV2S0FB'
});

const app = createApp(App);

// MIT preset configuration
const mitPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#F9FAFB',
            100: '#F3F4F6',
            200: '#E5E7EB',
            300: '#D1D5DB',
            400: '#9CA3AF',
            500: '#000000',
            600: '#374151',
            700: '#1F2937',
            800: '#111827',
            900: '#030712'
        }
    }
});

// Core setup
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: mitPreset,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
});

import '@/assets/primevue-overrides.css';

app.use(VueQueryPlugin);
app.use(gtag);

// Lazy load non-critical services
Promise.all([import('primevue/confirmationservice'), import('primevue/toastservice')]).then(([ConfirmationServiceModule, ToastServiceModule]) => {
    app.use(ToastServiceModule.default);
    app.use(ConfirmationServiceModule.default);
});

// Setup Pinia
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

// Load FontAwesome and icons before mounting
// Load icons configuration and mount app
import('@/config/icons').then(({ initializeIcons }) => {
    initializeIcons().then(() => {
        app.mount('#app');
    });
});
